import React from 'react';
import cn from 'classnames';
import { orderBy } from 'lodash';

const ClientTagPicker = ({ children, clientTags, itemClicked, showHideTag }) => (
  <div data-bem="ClientTagPicker" className="tags-list">
    {orderBy(clientTags, ['clicked', 'number_of_clients'], ['desc', 'desc']).map(
      ({ id, name, clicked, emoticon }, index) => (
        <div
          role="button"
          tabIndex={0}
          onClick={() => itemClicked(id)}
          className={cn({
            'tag-button tag-icon is': true,
            [name]: name,
            selected: clicked,
            'def-state ': !clicked,
            'show-label': index > 4 && showHideTag,
            'hide-label': index > 4 && !showHideTag,
          })}
          key={id}
        >
          <div className="emoticon">{emoticon}</div>
          <div className="name">{name}</div>
        </div>
      ),
    )}
    {children}
  </div>
);

export default ClientTagPicker;
